import { MonthlyPremium } from "./MonthlyPremium";
import { AnnualPremium } from "./AnnualPremium";

export type PremiumProps = {
  isMonthly: boolean;
  hasInstallments?: string | boolean;
  installmentsAmount?: string;
  premium: string;
};

export const Premium = (props: PremiumProps) => {
  const { isMonthly, hasInstallments, installmentsAmount, premium } = props;

  if (!isMonthly) {
    return <AnnualPremium premium={premium} />;
  }

  return hasInstallments && installmentsAmount ? (
    <MonthlyPremium installmentsAmount={installmentsAmount} />
  ) : (
    <AnnualPremium
      premium={premium}
      message="Monthly instalments not available"
    />
  );
};
